import axios from "axios";
import { baseUrl } from "../common/siteSettings";
import heyapi from "../middleware/axiosInstance";

export const getBlogs = async (token) => {
    try {
        const response = await heyapi.get(
            `/writer/blog/all`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const getBlogDetails = async (token, blogid) => {
    try {
        const response = await heyapi.get(
            `/writer/blog/details/${blogid}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const addBlog = async (token, blogid, blogData) => {
    try {
        const response = await heyapi.post(
            `/writer/blog/add?blogid=${blogid}`,
            blogData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const addCategory = async (token, name) => {
    try {
        const response = await heyapi.post(
            `/writer/category/add`,
            {name},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const getAllCategories = async (token, name) => {
    try {
        const response = await heyapi.get(
            `/writer/category/all`,
            name,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const getBlogDetailsFromSlug = async (slug) => {
    try {
        const response = await heyapi.get(
            `/blog/${slug}`,
            {
                
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const getBlogList = async (slug) => {
    try {
        const response = await heyapi.get(
            `/blog/list`,
            {
                
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};